import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import cadastrarEmpresa from '../../actions/empresa/cadastrarEmpresas'
import buscarEmpresas from '../../actions/empresa/buscarEmpresas';
import alterarEmpresa from '../../actions/empresa/alterarEmpresas'
import {
    renderFieldCheck,
    renderFieldCnpj,
    renderFieldDataNascimento,
    renderFieldEmail,
    renderFieldNotaEmpresa,
    renderFieldNumber,
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    renderFieldTelefone,
    required,
    tamanhoNotaEmpresa,
    tamanhoPorcentagem,
    minTamnhoCampo,
    validarIP,
    renderFieldMonetarioLabelEncima,
    maxValueMonetario,
} from '../../util/inputs';
import Select from 'react-select';
import { tipoIntegracao, tipoConfiguracaoConexaoTrecho } from '../../util/constantsUtil';
import RichTextEditor from '../RichTextEditor';
import DOMPurify from 'dompurify';


export const validate = (values) => {
    const erros = {};
    if (!values.nome) {
        erros.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        erros.email = 'Campo obrigatório'
    }
    return erros
};


const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        {label ? <label className='mt-2'>{label}</label> : ''}
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                style={{ borderColor: touched && error ? 'red' : '' }}
                id={input.name}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class DadosEmpresa extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChecked = this.handleChecked.bind(this);

        this.state = {
            mensagem: {
                tipo: '',
                texto: ''
            },
            usuario: null,
            tiposQualificacao: [],
            integracao: null            
        };
    }


    submit(values) {
        if (this.props.idEmpresa) {
            this.props.alterarEmpresa(this.props.montarParametroEmpresa(values))
                .then((resp) => {
                    if (resp.payload.status === 200) {
                        const mensagem = {
                            tipo: 'sucesso',
                            texto: 'Empresa atualizado com sucesso'
                        };
                        this.setState({
                            mensagem,
                            usuario: null
                        });
                        this.props.buscarEmpresas();
                    } else {
                        const mensagem = {
                            tipo: 'erro',
                            texto: resp.payload.response.data.mensagens[0].mensagem
                        };

                        this.setState({ mensagem });
                    }
                })
                .catch((error) => {
                    const mensagem = {
                        tipo: 'erro',
                        texto: error.response.data.message ? error.response.data.message : error.response.statusText
                    };
                    this.setState({
                        mensagem,
                        usuario: null
                    });
                })
        } else {
            this.props.cadastrarEmpresa(this.props.montarParametroEmpresa(values))
                .then((resp) => {
                    if (resp.payload.status === 200) {
                        this.props.reset('formularioCadastroEmpresa');
                        const mensagem = {
                            tipo: 'sucesso',
                            texto: 'Empresa cadastrada com sucesso'
                        };
                        this.setState({
                            mensagem,
                            usuario: null
                        });
                        this.props.buscarEmpresas();
                    } else {
                        const mensagem = {
                            tipo: 'erro',
                            texto: resp.payload.response.data.mensagens[0].mensagem
                        };

                        this.setState({
                            mensagem,
                            usuario: null
                        });
                    }
                })
                .catch((error) => {
                    const mensagem = {
                        tipo: 'erro',
                        texto: error.response.data.message ? error.response.data.message : error.response.statusText
                    };
                    this.setState({
                        mensagem,
                        usuario: null
                    });
                })
        }
    }

    handleChange(event) {
        this.limparMensagem();
        const file = event.target.files[0];
        if (/\.(jpe?g|png|webp)$/i.test(file.name) === false) {
            const mensagem = {
                tipo: 'erro',
                texto: 'Formato de imagem inválido. Informe uma imagem nos formatos JPEG ou PNG.'
            };
            this.setState({ mensagem });
            return
        }
        const logomarca = file.name;
        this.setState({ logomarca });
        this.converterParaBase64(file, logomarca)
    }

    handleSelecionarSite(evento) {
        this.props.selecionarSite(evento);
    }

    handleSelecionarIntegracao(evento) {
        this.setState({ integracao: evento })
    }

    handleSelecionarPagamentosDesativados(evento){
        // this.setState({ pagamentosDesativados: evento })
        this.props.adicionarPagamentoDesativado(evento);
    }

    // eslint-disable-next-line class-methods-use-this
    converterParaBase64(file, logomarca) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formularioCadastroEmpresa',
                'logoMarca', reader.result);
            this.props.changeFieldValue('formularioCadastroEmpresa',
                'logomarca', logomarca);

        }.bind(this);
        reader.onerror = function () {
            const mensagem = {
                tipo: 'erro',
                texto: 'Imagem inválida. Selecione outra imagem.'
            };
            this.setState({ mensagem });
            this.removerImagem();
        }.bind(this);
    }

    limparMensagem() {
        this.setState({ mensagem: undefined })
    }

    recuperaMensagem() {
        if (this.state.mensagem !== null && this.state.mensagem !== undefined) {
            if (this.state.mensagem.tipo === 'sucesso') {
                return (
                    <div className="alert alert-success col-md-12">
                        {this.state.mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                            onClick={() => {
                                this.limparMensagem();
                                this.setState({ usuario: null })
                            }
                            }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
            if (this.state.mensagem.tipo === 'erro') {
                return (
                    <div className="alert alert-danger col-md-12">
                        {this.state.mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                            onClick={() => {
                                this.limparMensagem();
                            }
                            }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
        }
        return ''
    }

    limparFormulario() {
        this.props.reset('formularioCadastroEmpresa');
        this.limparMensagem();
        this.removerImagem();
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'ddd', '');
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'celular', '');
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'email', '');
        this.setState({
            marcacaoLida: false,
            usuario: null
        });
    }

    handleExibirCamposBPE() {
        if (this.props.habilitadoBpe) {
            this.limparInformacoesBPE()
        }
    }

    handleExibirCamposBPESites() {
        if (this.props.habilitadoBpeSites) {
            this.props.changeFieldValue('formularioCadastroEmpresa',
                'habilitadoBpeSites', '');
        }
    }

    handleCheckedTEF() {
        const novoValor = !this.props.habilitadoTEF;
        if (!novoValor) {
            this.props.changeFieldValue('formularioCadastroEmpresa', 'ipTEF', '');
        }
    }

    handleCheckedPrecoFixoExcessoBagagem() {
        const novoValor = !this.props.habilitadoPrecoFixoExcessoBagagem;
        if (!novoValor) {
            this.props.changeFieldValue('formularioCadastroEmpresa', 'precoFixoExcessoBagagem', '');
        }
    }

    exibirImagem() {
        if (this.props.logoMarca || this.props.urlImagem) {
            return (<div style={{ marginLeft: 10 }}>
                <img alt='' style={{ width: '20%' }}
                    src={this.props.logoMarca ? this.props.logoMarca : this.props.urlImagem} />
                <button type="button" className="btn btn-editar mt-5"
                    title='Remover'
                    onClick={() => this.removerImagem()}>
                    <i className="material-icons nav-icon" style={{
                        fontSize: 18,
                        color: 'red'
                    }}>&#xe5cd;</i>
                </button>
            </div>)
        }
    }

    removerImagem() {
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'logoMarca', null);
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'urlImagem', null);
    }

    limparInformacoesBPE() {
        this.props.changeFieldValue('formularioCadastroEmpresa',
            'ie', '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'im', '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'cnae', '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'tar', '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadoBpe', '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'habilitadaVendaSeguro', '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'nomeCertificado', '');

        this.props.changeFieldValue('formularioCadastroEmpresa',
            'senhaCertificado', '');

        this.props.removeArquivo();

    }

    exibirSites() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr colSpan='2' className='text-center'>
                    <th>Sites selecionados</th>
                </tr>
            </thead>
            <tbody>
                {!this.props.sitesSelecionados || this.props.sitesSelecionados.length === 0 ?
                    <tr colSpan='2' className="alert alert-warning text-center mt-4" role="alert">Nenhum site foi
                        selecionado.</tr>
                    :
                    this.props.sitesSelecionados
                        .map((site, index) => <tr key={`site_${index}`}>
                            <td>
                                {site.label}
                            </td>
                            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                <div onClick={() => this.props.removerSite(site.value)}>Remover</div>
                            </td>
                        </tr>)}
            </tbody>
        </table>
    }

    exibirPagamentosDesativados() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr colSpan='2' className='text-center'>
                    <th>Tipos Pagamentos</th>
                </tr>
            </thead>
            <tbody>
                {!this.props.pagamentosDesativadosSelecionados || this.props.pagamentosDesativadosSelecionados.length === 0 ?
                    <tr colSpan='2' className="alert alert-warning text-center mt-4" role="alert">Nenhum Tipo pagamento
                        selecionado.</tr>
                    :
                    this.props.pagamentosDesativadosSelecionados
                        .map((it) => <tr key={`pagamentos_desativados_${it.value}`}>
                            <td>
                                {it.label}
                            </td>
                            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                <div onClick={() => this.props.removerPagamentosDesativados(it)}>Remover</div>
                            </td>
                        </tr>)}
            </tbody>
        </table>
    }

    exibirIntegracoes() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr colSpan='2' className='text-center'>
                    <th>Integraçãos</th>
                    <th>Código Empresa</th>
                    <th>Habilitado</th>
                </tr>
            </thead>
            <tbody>
                {!this.props.integracaoSelecionada || this.props.integracaoSelecionada.length === 0 ?
                    <tr colSpan='4' className="alert alert-warning text-center mt-4" role="alert" key={`it_${'index'}`}>
                        Nenhum site foi selecionado.</tr>
                    :
                    this.props.integracaoSelecionada.map((it, index) => <tr key={`it_${index}`}>
                        <td>
                            {it.integracao.value}
                        </td>
                        <td className='text-center'>
                            {it.codigoEmpresa}
                        </td>
                        <td className='text-center'>
                            <input type="checkbox" name={null} value={it.integracaoAtiva} checked={it.integracaoAtiva} onChange={() => this.props.handleCheckIntegracaoAtiva(it)} style={{ cursor: 'pointer' }} />
                        </td>
                        <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                            <div onClick={() => this.props.removerIntegracao(it)}>Remover</div>
                        </td>
                    </tr>)}
            </tbody>
        </table>
    }

    adicionarIntegracao(event) {
        event.preventDefault();
        this.props.adicionarIntegracao({
            id: null,
            integracao: this.state.integracao,
            codigoEmpresa: this.props.codigoEmpresaIntegracao,
            integracaoAtiva: false
        });
        this.limparCamposIntegracao();
    }

    limparCamposIntegracao() {
        this.props.changeFieldValue('formularioCadastroEmpresa', 'integracao', '');
        this.props.changeFieldValue('formularioCadastroEmpresa', 'codigoEmpresaIntegracao', '');
    }

    adicionarPagamentoDesativado(event) {
        event.preventDefault();        
        this.props.adicionarPagamentoDesativado({
           tipoPagamento: event.target.value
        })
    }

    desmarcarCheckboxHabilitadoAgencia(e) {
        if (!e.target.checked) {
            this.props.changeFieldValue('formularioCadastroEmpresa', 'habilitadoAgencia', false);
        }
    }

    handleChecked() {
        this.props.handleCheckedRegraConexaoTrecho();
    }

    exibirCheckboxConfiguracaoConexaoTrecho() {
        return (
            <div className="form-group">
                <label htmlFor='habilitadoRegraConexaoTrecho'>Configuração Conexão de Trecho</label>
                <div className='form-group form-check'>
                    <input type="radio" name='habilitadoRegraConexaoTrecho'
                        className='form-check-input' onChange={this.handleChecked} value={this.props.habilitadoRegraConexaoTrecho} checked={this.props.habilitadoRegraConexaoTrecho} />
                    <label className='form-check-label'>{tipoConfiguracaoConexaoTrecho.regraAtual.valor}</label>
                </div>
                <div className='form-group form-check'>
                    <input type="radio" name='habilitadoRegraConexaoTrecho'
                        className='form-check-input' onChange={this.handleChecked} value={!this.props.habilitadoRegraConexaoTrecho} checked={!this.props.habilitadoRegraConexaoTrecho} />
                    <label className='form-check-label'>{tipoConfiguracaoConexaoTrecho.regraAntiga.valor}</label>
                </div>
            </div>
        )
    }

    render() {
        const {
            handleSubmit,
            submitting,
            invalid,
            rodoviaria,
            turismo,
            empresa
        } = this.props;
        const ehEdicao = empresa && empresa.id ? true : false;
        const validarRodovTurismo = rodoviaria || turismo;
        return (
            <div className="modal-body">
                {this.recuperaMensagem()}
                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="cnpj" type="text" validate={[required]} component={renderFieldCnpj}
                                label="CNPJ/CPF:"
                                css="form-control" readOnly={false} />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-9 col-md-9">
                            <Field name="razaoSocial" type="text" component={renderField} label="Razão social:"
                                css="form-control" readOnly={false} />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12 col-sm-9 col-md-9">
                            <Field name="nomeFantasia" type="text" component={renderField} label="Nome fantasia:"
                                css="form-control" readOnly={false} />
                        </div>
                    </div>
                    <div className="form-group">
                        <Field name="telefoneEmpresa" type="text" component={renderFieldTelefone}
                            css="form-control col-md-6" label="Telefone" />
                    </div>
                    <div className="form-group">
                        <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                            css="form-control col-md-6" readOnly={ehEdicao} />
                    </div>

                    <div className='form-row'>
                        <div className='col-12 col-sm-3 col-md-3'>
                            <Field name='rodoviaria' type="checkbox" component={renderFieldCheck}
                                label="Rodoviária"
                                css="form-check-input" readOnly={false} />
                        </div>
                        <Field name='turismo' type="checkbox" component={renderFieldCheck}
                            label="Turismo"
                            css="form-check-input" readOnly={false} />
                    </div>

                    {this.props.turismo ?
                        <div className="form-group">
                            <Field name="senhaAntt" type="text" component={renderField} label="Senha ANTT:"
                                validate={[required, minTamnhoCampo]}
                                css="form-control col-md-4"
                                readOnly={false} />
                        </div> : ''}

                    <div className="form-group">
                        <Field name='multaRemarcacaoCancelamentoDentroPrazo' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            css="form-control col-md-2" label="Remarcação/Cancelamento no prazo(%)" />
                    </div>

                    <div className="form-group">
                        <Field name='multaRemarcacaoCancelamentoForaPrazo' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            css="form-control col-md-2" label="Remarcação/Cancelamento fora do prazo(%)" />
                    </div>
                    <div className="form-group">
                        <Field name='habilitadoEncomenda' type="checkbox" component={renderFieldCheck}
                            label="Habilitar para encomenda"
                            css="form-check-input" readOnly={false} />
                    </div>
                    <div className="form-group">
                        <Field name='permitirRemarcacaoCancelamentoSite' type="checkbox" component={renderFieldCheck}
                            label="Permitir Remarcação/Cancelamento Site"
                            css="form-check-input" readOnly={false} />
                    </div>
                    <div className="form-group">
                        <Field name='habilitadoVendeGratuidadeApenasConvencional' type="checkbox" component={renderFieldCheck}
                            label="Habilitar Vender Gratuidade Apenas Convencional"
                            css="form-check-input" readOnly={false} />
                    </div>
                    <div className="form-group">
                        <Field name='habilitadoVenderCpfOpcional' type="checkbox" component={renderFieldCheck}
                            label="Habilitar Vender com CPF Opcional"
                            css="form-check-input" readOnly={false} />
                    </div>
                    <div className="form-group">
                        <Field name='habilitadoExibirApenasTipoDocumentoPassaporte' type="checkbox" component={renderFieldCheck}
                            label="Habilitar Exibir Apenas Documento Passaporte"
                            css="form-check-input" readOnly={false} />
                    </div>

                    <Field name='habilitadoBpe' type="checkbox" component={renderFieldCheck}
                        label="Habilitar para emissão de BPe"
                        onChange={() => this.handleExibirCamposBPE()}
                        css="form-check-input" readOnly={false} />

                    {this.props.habilitadoBpe &&
                        <div className="form-row mb-3">
                            <div className="col-12 col-sm-12 col-md-4">
                                <Field name="tipoControleEmissaoBpe" type="text" 
                                    component={renderField} label='Controle Emissão Bpe:'
                                    css="form-control" readOnly={true}/>
                            </div>
                        </div>}

                    <Field name='habilitadoBpeSites' type="checkbox" component={renderFieldCheck}
                        label="Habilitar para emissão de BPe nos SITES/AGÊNCIAS"
                        onChange={() => this.handleExibirCamposBPESites()}
                        css="form-check-input" readOnly={false} />

                    <Field name='habilitadaVendaSeguro' type="checkbox" component={renderFieldCheck}
                        label="Habilitar venda de seguro"
                        css="form-check-input" readOnly={false} />

                    <Field name='habilitadoRegraBilhete' type="checkbox" component={renderFieldCheck}
                                label="Habilitar Regra Bilhete"
                                css="form-check-input mt-2" />

                    <Field name='habilitadoBuscaPassagemHorario' type="checkbox" component={renderFieldCheck}
                                label="Habilitar Busca Passagem Por Horário"
                                css="form-check-input mt-2" />
                    
                    <Field name='habilitadoCpfCnpjTitularCompravante' type="checkbox" component={renderFieldCheck}
                                label="Habilitar Cpf CNPJ Titular Comprovante Fechamento Caixa"
                                css="form-check-input mt-2" />
                                        
                    <Field name='habilitadoTEF'
                        type="checkbox" component={renderFieldCheck}
                        label="Habilitar Venda TEF"
                        onChange={() => this.handleCheckedTEF()}
                        css="form-check-input mt-2" />

                    {this.props.habilitadoTEF && (<>
                        <div className="form-group">
                            <Field name="ipTEF" type="text"
                                component={renderField}
                                formatacao="###.###.###.###"
                                label="IP do Servidor TEF"
                                css="form-control col-md-4"
                                validate={[required, validarIP]}
                            />
                      </div>                      
                    </>)}

                    <Field name='habilitadoPrecoFixoExcessoBagagem'
                        type="checkbox" component={renderFieldCheck}
                        label="Habilitar Preço Fixo Excesso Bagagem"
                        onChange={() => this.handleCheckedPrecoFixoExcessoBagagem()}
                        css="form-check-input mt-2" />

                    {this.props.habilitadoPrecoFixoExcessoBagagem && <div className="form-row mb-4"><Field
                        name="precoFixoExcessoBagagem"
                        validate={[maxValueMonetario, required]}
                        component={renderFieldMonetarioLabelEncima}
                        label="Preço fixo Excesso Bagagem:"
                        css="form-control col-md-4"
                    /></div>}


                    <Field name='habilitadoSite' type="checkbox" component={renderFieldCheck}
                        onChange={(e) => this.desmarcarCheckboxHabilitadoAgencia(e)}
                        label="Habilitar para vendas no site"
                        css="form-check-input mt-2" />
                    
                    {this.props.habilitadoSite ?
                        <React.Fragment>
                            <Field name='habilitadoAntt' type="checkbox" component={renderFieldCheck}
                                label="Vender com valor ANTT"
                                css="form-check-input mt-2" />

                            <Field name='habilitadoAgencia' type="checkbox" component={renderFieldCheck}
                                label="Habilitar para vendas nas agências"
                                css="form-check-input mt-2" />
                        </React.Fragment> : ''}

                    {this.props.habilitadoAgencia ?
                        <React.Fragment>
                            <div className="form-row">
                                <Field name='impostoPraticar' validate={[required, tamanhoPorcentagem]}
                                    component={renderFieldNumerosPorcentagem}
                                    css="form-control col-md-7" label="Imposto a Praticar(%)" />
                                <Field name='comissaoPraticar' validate={[required, tamanhoPorcentagem]}
                                    component={renderFieldNumerosPorcentagem}
                                    css="form-control col-md-7" label="Comissão a Praticar(%)" />
                            </div>
                            <div className="mt-4 mb-1"><h5><strong>Comissões das Agências</strong></h5></div>
                            <div className="form-row">
                                <Field name='agenteTipoUm' validate={[required, tamanhoPorcentagem]}
                                    component={renderFieldNumerosPorcentagem}
                                    css="form-control col-md-7" label="Agente Tipo 1(%)" />
                                <Field name='agenteTipoDois' validate={[required, tamanhoPorcentagem]}
                                    component={renderFieldNumerosPorcentagem}
                                    css="form-control col-md-7" label="Agente Tipo 2(%)" />
                                <Field name='agenteTipoTres' validate={[required, tamanhoPorcentagem]}
                                    component={renderFieldNumerosPorcentagem}
                                    css="form-control col-md-7" label="Agente Tipo 3(%)" />
                            </div>
                        </React.Fragment> : ''}

                    {this.props.habilitadoSite ?
                        <React.Fragment>
                            <div className="form-row mt-2">
                                <div className="col-12 col-sm-12 col-md-9">
                                    <div>
                                        <label className='mt-2'>Sites</label>
                                        <Select
                                            placeholder='Selecione o site'
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    height: 35,
                                                    minHeight: 32,
                                                    fontSize: 16,
                                                    width: '100%',
                                                    borderColor: '#e4e7ea',
                                                    cursor: 'pointer'
                                                })
                                            }}
                                            value={null}
                                            noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                            options={this.props.plataformas.filter(it => !this.props.sitesSelecionados.map(it => it.value).includes(it) && it != 'Todas')
                                                .map(elemento => ({
                                                    label: elemento,
                                                    value: elemento
                                                }))}
                                            onChange={e => this.handleSelecionarSite(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row mt-2">
                                <div className="col-12 col-sm-12 col-md-9">
                                    <div className="lista-table">
                                        {this.exibirSites()}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment> : ''}

                    <div className="form-row mt-2 mb-2">
                        <div className="col-12 col-sm-12 col-md-4">
                            <Field name="numeroNotaCte" type="text" component={renderFieldNumber}
                                formatacao='#########'
                                readOnly={false}
                                label="Número Nota Cte:"
                                css="form-control" />
                        </div>
                    </div>
                    <div className="form-row mt-2 mb-2">
                        <div className="col-12 col-sm-12 col-md-4">
                            <Field name="numeroNotaCteOs" type="text" component={renderFieldNumber}
                                formatacao='#########'
                                readOnly={false}
                                label="Número Nota Cte Os:"
                                css="form-control" />
                        </div>
                    </div>

                    {this.exibirCheckboxConfiguracaoConexaoTrecho()}

                    <div className="form-row mt-2 mb-2">
                        <div className="col-12 col-sm-12 col-md-9">
                            <Field
                                name='avaliacaoEmpresa'
                                validate={[tamanhoNotaEmpresa]}
                                component={renderFieldNotaEmpresa}
                                css="form-control col-md-7"
                                label='Avaliação nota empresa'
                                placeholder='Avalie'
                            />
                        </div>
                    </div>
                    <div className="form-row mt-2 mb-2">
                        <div className="col-12 col-sm-12 col-md-9">
                            <Field name='grupo'
                                options={this.props.grupos.map(elemento => ({
                                    descricao: elemento,
                                    nome: elemento
                                }))}
                                component={renderFieldSelect}
                                label='Grupos'
                                placeholder='Selecione...'
                                isClearable={true}
                            />
                        </div>
                    </div>
                    <React.Fragment>
                        <div className="form-row mt-2">
                            <div className="col-12 col-sm-12 col-md-9">
                                <div>
                                    <label className='mt-2'>Integração</label>
                                    <Select
                                        name='integracao'
                                        placeholder='Selecione a integração'
                                        styles={{
                                            control: base => ({
                                                ...base,
                                                height: 35,
                                                minHeight: 32,
                                                fontSize: 16,
                                                width: '100%',
                                                borderColor: '#e4e7ea',
                                                cursor: 'pointer'
                                            })
                                        }}
                                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                        options={tipoIntegracao.filter(it => !this.props.integracaoSelecionada.map(is => {
                                            if (is.integracao) {
                                                return is.integracao.value
                                            }
                                        }).includes(it.value))}
                                        onChange={e => this.handleSelecionarIntegracao(e)} />

                                    <Field
                                        name="codigoEmpresaIntegracao"
                                        type="text"
                                        component={renderField}
                                        label="Código Empresa"
                                        css="form-control"
                                    />

                                    <div className="col-12 col-sm-3 col-md-3">

                                        <div className="col-12 col-sm-12 col-md-12 mt-3 mb-3">
                                            <button
                                                disabled={!this.state.integracao || !this.props.codigoEmpresaIntegracao}
                                                type="submit"
                                                className="btn btn-sm btn-laranja"
                                                onClick={(e) => this.adicionarIntegracao(e)}
                                            >Incluir
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row mt-2">
                            <div className="col-12 col-sm-12 col-md-9">
                                <div className="lista-table">
                                    {this.exibirIntegracoes()}
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    {this.props.grupo === undefined || this.props.grupo === null || this.props.grupo.value !== 'BUSER' ?
                        <Field name='habilitadoEnvioWpp' type="checkbox" component={renderFieldCheck}
                            label="Habilitar para envio de WhatsApp"
                            css="form-check-input" readOnly={false} /> : ''}
                    <Field name='habilitadoBuscaReservaComBpe' type="checkbox" component={renderFieldCheck}
                        label="Reservas com BPe"
                        css="form-check-input" />

                    {this.props.habilitadoBuscaReservaComBpe ?
                        <Field name="dataIniciaoVigenciaBuscaReservaComBpe" type="text"
                            component={renderFieldDataNascimento}
                            validate={[required]}
                            css="form-control col-md-2 mb-2" label="Data de reservas com BPe" /> : ''}
                    <Field name="tempoVisualizacaoDados" type="text" component={renderFieldNumber}
                        formatacao="##"
                        label="Tempo de visualização de dados(em Dias):"
                        css="form-control col-md-2" readOnly={false} />

                    <React.Fragment>
                        <div className="form-row mt-2">
                            <div className="col-12 col-sm-12 col-md-9">
                                <div>
                                    <label className='mt-2'>Pagamentos Desativados</label>
                                    <Select
                                        name='pagamentosDesativados'
                                        placeholder='Selecione o Tipo Pagamento'
                                        styles={{
                                            control: base => ({
                                                ...base,
                                                height: 35,
                                                minHeight: 32,
                                                fontSize: 16,
                                                width: '100%',
                                                borderColor: '#e4e7ea',
                                                cursor: 'pointer'
                                            })
                                        }}
                                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                        options={this.props.tipoPagamentos
                                            .filter(it => !this.props.pagamentosDesativadosSelecionados
                                                .map(tp => tp.value)
                                                .includes(it.chave))
                                            .map(it => {                                            
                                            return  { label: it.valor, value: it.chave }
                                        })}
                                        onChange={e => this.handleSelecionarPagamentosDesativados(e)} />                                    
                                </div>
                            </div>
                        </div>
                        <div className="form-row mt-2">
                            <div className="col-12 col-sm-12 col-md-9">
                                <div className="lista-table">
                                    {this.exibirPagamentosDesativados()}
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                    <div className="form-group">
                        <Field
                            name="mensagemAvisoBilhete"
                            component={RichTextEditor}
                            label="Mensagem em bilhete:"
                            />

                            {this.props.mensagemAvisoBilhete && (
                            <div className="form-group mt-2">
                                <label><strong>Pré-visualização do bilhete:</strong></label>
                                <div
                                style={{ border: '1px solid #ccc', padding: 10 }}
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(this.props.mensagemAvisoBilhete),
                                }}
                                />
                            </div>
                            )}

                    </div>
                    <div className="form-group">
                        <div>
                            <label>Logomarca:</label>
                        </div>
                        <div className='input-wrapper'>
                            <label htmlFor='input-file'>
                                {this.props.logoMarca ? 'Alterar Logomarca' : 'Selecionar Logomarca'}
                            </label>
                            <input id='input-file' type='file' value='' accept="image/*" onChange={this.handleChange} />
                            <span id='file-name' />
                        </div>
                    </div>
                    <div className="form-group">
                        {this.exibirImagem()}
                    </div>
                    <Field name='opcoesTrechoAlternativo' type="checkbox" component={renderFieldCheck}
                        label="Exibir trecho alternativo"
                        css="form-check-input" readOnly={false} />
                    <div className="form-group">
                    </div>
                    <div className="form-group area-codigo">
                        <Field name="codigoUsuario" type="hidden" component={renderField} css="form-control col-md-12" />
                        <Field name="nomeCertificado" type="hidden" component={renderField}
                            css="form-control col-md-12" />
                        <Field name="certificado" type="hidden" component={renderField} css="form-control col-md-12" />
                    </div>

                    <div className="modal-footer">
                        <button type="submit"
                            disabled={invalid || submitting || !validarRodovTurismo}
                            className="btn btn-laranja">
                            Avançar
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export function mapStateToProps(state) {    
    return {
        plataformas: state.plataformas,
        idEmpresa: formValueSelector('formularioCadastroEmpresa')(state, 'idEmpresa'),
        mensagemAvisoBilhete: formValueSelector('formularioCadastroEmpresa')(state, 'mensagemAvisoBilhete'),
        nome: formValueSelector('formularioCadastroEmpresa')(state, 'nome'),
        tempoVisualizacaoDados: formValueSelector('formularioCadastroEmpresa')(state, 'tempoVisualizacaoDados'),
        habilitadoBpe: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoBpe'),
        habilitadaVendaSeguro: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadaVendaSeguro'),
        habilitadoSite: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoSite'),
        habilitadoBuscaReservaComBpe: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoBuscaReservaComBpe'),
        dataIniciaoVigenciaBuscaReservaComBpe: formValueSelector('formularioCadastroEmpresa')(state, 'dataIniciaoVigenciaBuscaReservaComBpe'),
        nomeCertificado: formValueSelector('formularioCadastroEmpresa')(state, 'nomeCertificado'),
        email: formValueSelector('formularioCadastroEmpresa')(state, 'email'),
        certificado: formValueSelector('formularioCadastroEmpresa')(state, 'certificado'),
        logoMarca: formValueSelector('formularioCadastroEmpresa')(state, 'logoMarca'),
        logomarca: formValueSelector('formularioCadastroEmpresa')(state, 'logomarca'),
        urlImagem: formValueSelector('formularioCadastroEmpresa')(state, 'urlImagem'),
        habilitadoAgencia: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoAgencia'),
        habilitadoAntt: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoAntt'),
        avaliacaoEmpresa: formValueSelector('formularioCadastroEmpresa')(state, 'avaliacaoEmpresa'),
        habilitadoBpeSites: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoBpeSites'),
        rodoviaria: formValueSelector('formularioCadastroEmpresa')(state, 'rodoviaria'),
        turismo: formValueSelector('formularioCadastroEmpresa')(state, 'turismo'),
        senhaAntt: formValueSelector('formularioCadastroEmpresa')(state, 'senhaAntt'),
        habilitadoEnvioWpp: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoEnvioWpp'),
        grupo: formValueSelector('formularioCadastroEmpresa')(state, 'grupo'),
        codigoEmpresaIntegracao: formValueSelector('formularioCadastroEmpresa')(state, 'codigoEmpresaIntegracao'),
        integracaoAtiva: formValueSelector('formularioCadastroEmpresa')(state, 'integracaoAtiva'),
        numeroNotaCte: formValueSelector('formularioCadastroEmpresa')(state, 'numeroNotaCte'),
        numeroNotaCteOs: formValueSelector('formularioCadastroEmpresa')(state, 'numeroNotaCteOs'),
        habilitadoRegraBilhete: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoRegraBilhete'),
        tipoControleEmissaoBpe: formValueSelector('formularioCadastroEmpresa')(state, 'tipoControleEmissaoBpe'),        
        habilitadoBuscaPassagemHorario: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoBuscaPassagemHorario'),        
        habilitadoVendeGratuidadeApenasConvencional: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoVendeGratuidadeApenasConvencional'),        
        habilitadoVenderCpfOpcional: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoVenderCpfOpcional'),
        habilitadoExibirApenasTipoDocumentoPassaporte: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoExibirApenasTipoDocumentoPassaporte'),
        habilitadoTEF: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoTEF'),
        ipTef: formValueSelector('formularioCadastroEmpresa')(state, 'ipTEF'),
        habilitadoCpfCnpjTitularCompravante: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoCpfCnpjTitularCompravante'),
        tipoPagamentos: state.filtrosEmpresas.tipoPagamentos ? state.filtrosEmpresas.tipoPagamentos : [],
        habilitadoPrecoFixoExcessoBagagem: formValueSelector('formularioCadastroEmpresa')(state, 'habilitadoPrecoFixoExcessoBagagem'),
        precoFixoExcessoBagagem: formValueSelector('formularioCadastroEmpresa')(state, 'precoFixoExcessoBagagem')

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarEmpresa,
        buscarEmpresas,
        alterarEmpresa,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroEmpresa',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
})(DadosEmpresa));
